export default {
	"billingItems": {
		"name": "计费项名称",
		"type": "级别",
		"billingItemInfo": "计费项信息",
		"billingItemCodeTips": "请输入计费项编码(最长32字)",
		"billingItemNameTips": "请输入计费项名称(最长32字)",
		"addBillingItem": "添加计费项",
		"trunk": "干线",
		"distribution": "宅配",
		"storage": "仓储",
		"appreciation": "增值"
	},
	"billingRules": {
		"ruleName": "规则名称",
		"remark": "规则说明",
		"rule": "计算规则",
		"billingRule": "计费规则",
		"ruleTips": "请输入计算规则(最长6000字)",
		"ruleTest": "你可在此测试",
		"invokeParam": "填写试算需要的参数值（最长2000字）",
		"startTest": "开始测试",
		"getReturnResult": "点击开始测试返回测试结果。",
		"addBillingRules": "添加计费规则"
	},
	"billingShares": {
		"shareName": "分摊规则名",
		"rule": "分摊配置",
		"shareNameTips": "请输入分摊规则名(最长20字)",
		"ruleCodeTips": "请输入规则编码(最长32字)",
		"ruleTips": "请输入分摊配置(最长6000字)",
		"invokeParam": "填写试算需要的参数值（最长500字）",
		"addShareRules": "添加分摊规则"
	},
	"calculatorManage": {
		"name": "计费器",
		"date": "日期",
		"time": "时间",
		"manualTrigger": "手工触发",
		"calculatorInfo": "计费器信息",
		"nameTips": "请输入计费器名称(最长32字)",
		"realTime": "实时",
		"everyday": "每日",
		"calculationTask": "计算任务",
		"calculationTaskConfig": "计算任务配置",
		"quoteTypeTips": "请先选择合同类型",
		"addCalculator": "添加计费器",
		"number": "号",
		"spot": "点",
		"refreshTips": "基础数据加载失败，请尝试按F5刷新页面后重试。"
	},
	"contractManage": {
		"contractNoLike": "合同号/外部合同号",
		"serviceProducts": "服务产品/项目",
		"createDtInitData": "创建时段",
		"startInitData": "生效时段",
		"endInitData": "失效时段",
		"renew": "续签",
		"switch": "切换",
		"dateChange": "生效期调整",
		"quoteMaintain": "维护报价",
		"fileAdmin": "附件管理",
		"mainContractNo": "主合同ID",
		"pleaseInputLightRatio": "请输入泡重比（大于0小于999的数字）",
		"contractRenewal": "合同续签",
		"contractSwitch": "合同切换",
		"splitData": "切换日期",
		"contractFileAdmin": "合同附件管理",
		"addContract": "创建合同",
		"threeMonthsAgo": "前三个月",
		"aMonthsAgo": "前一个月",
		"aWeekAgo": "前一周",
		"aWeekLater": "后一周",
		"aMonthsLater": "后一个月",
		"threeMonthsLater": "后三个月",
		"noProductInformation": "无法识别的产品信息。",
		"duplicateProductInformation": "重复的产品信息",
		"nocontractData": "无法识别的合同数据。",
		"contractCannotBeDeleted": "无法删除合同",
		"onlyNewCanBeDeleted": "只能删除新建的合同。",
		"pleaseSelectDate": "请选择生效日期和失效日期。",
		"errDateTips": "生效日期不能晚于失效日期。",
		"confirmRenew": "确定要续签吗",
		"pleaseSelectSwitchingDate": "请选择切换日期",
		"confirmSwitch": "确定要切换吗?",
		"sequenceNoTips": "请输入序号",
		"curSequenceNo": "当前序号为",
		"inputTips": "请输入不大于7位的整数。"
	},
	"dataResource": {
		"sourceFeture": "数据源属性",
		"dataResourceInfo": "数据源信息",
		"dataResourceTips": "请输入数据源名(最长20字)",
		"sourceType": "数据源类型",
		"sourceFetureTips": "请选择数据源属性",
		"sourceContextTips": "请输入配置(最长4000字)",
		"testTips": "您可在此测试",
		"inputTips": "填写参数值（最长500字）",
		"addDataResource": "添加数据源"
	},
	"motherTemplate": {
		"motherboardName": "母板名称",
		"downloadMotherboard": "下载母板",
		"upload": "上传",
		"motherboardInfo": "母板信息",
		"quoteMotherboardName": "报价母板名称",
		"addMotherboard": "添加母板"
	},
	"quoteMaintain": {
		"quotationTemplate": "报价模板",
		"content": "内容",
		"importQuotation": "导入报价",
		"exportQuotation": "导出报价",
		"clearQuotation": "清除报价",
		"pleaseClick": "请点选上面的报价模板...",
		"importQuotationSuccess": "报价导入成功",
		"revokeOperation": "是否确认进行撤销操作？",
		"changeNew": "确认让合同变为新建状态？",
		"noTemplateNotQuotation": "没有报价模板不能导入报价,请上传模板后重试。",
		"contractAdmin": "合同管理",
		"noserviceProduct": "你还没有设置服务产品！"
	},
	"serviceitems": {
		"choseNode": "选择时间点",
		"serviceType": "服务类型",
		"serviceName": "服务名称",
		"serviceNameTips": "请输入服务名称(最长32字)",
		"provider": "服务方",
		"synmode": "业务同步方式",
		"codeTips": "请输入编码(最长32字)",
		"custom": "业务自定义",
		"unit": "报价单位",
		"unitTips": "请输入报价单位(最大32位)",
		"addService": "新建服务项",
		"inputSequenceNo": "请输入序号",
		"curSequenceNo": "当前序号为",
		"inputErrorMessage": "请输入不大于7位的整数"
	},
	"account": {
		"companyName": "企业名称",
		"businessLicense": "营业执照号",
		"nature": "性质",
		"parentCompany": "上级企业",
		"shortName": "简 称",
		"address": "通讯地址",
		"contact": "联系人",
		"addContact": "添加联系人",
		"mobile": "手机",
		"email": "邮箱",
		"duty": "职务",
		"uploadLogo": "上传头像"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/account/account.js